<template>
  <div>
    <div class="section !py-0">
      <div
        class="container flex items-center border-b border-b-border py-4 tablet:py-6"
      >
        <Logo top="Error" color="primary" bottom="Zürich, Switzerland" />
      </div>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
